import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiX, FiSearch } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const DashboardOrganisasi = () => {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ nama: '', singkatan: '', deskripsi: '', kepala: '', alamat: '', telepon: '', email: '' });
  const [search, setSearch] = useState('');

  const load = async () => {
    try { const res = await api.get('/admin/organisasi'); setOrgs(res.data.data); } catch (e) { toast.error('Gagal memuat'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) { await api.put(`/admin/organisasi/${editId}`, form); toast.success('Organisasi diperbarui'); }
      else { await api.post('/admin/organisasi', form); toast.success('Organisasi ditambahkan'); }
      setShowModal(false); setEditId(null); setForm({ nama: '', singkatan: '', deskripsi: '', kepala: '', alamat: '', telepon: '', email: '' }); load();
    } catch (e) { toast.error('Gagal menyimpan'); }
  };

  const handleEdit = (o) => {
    setEditId(o._id);
    setForm({ nama: o.nama, singkatan: o.singkatan || '', deskripsi: o.deskripsi || '', kepala: o.kepala || '', alamat: o.alamat || '', telepon: o.telepon || '', email: o.email || '' });
    setShowModal(true);
  };

  return (
    <div>
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div><h2>Kelola Organisasi</h2><p>{orgs.length} OPD terdaftar</p></div>
        <button className="btn btn-primary" onClick={() => { setEditId(null); setForm({ nama: '', singkatan: '', deskripsi: '', kepala: '', alamat: '', telepon: '', email: '' }); setShowModal(true); }}><FiPlus /> Tambah</button>
      </div>

      <div style={{ marginBottom: '1.5rem', position: 'relative' }}>
        <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)' }} />
        <input 
          className="form-input" 
          placeholder="Cari Organisasi / OPD..." 
          value={search} 
          onChange={(e) => setSearch(e.target.value)} 
          style={{ paddingLeft: '35px', maxWidth: '400px' }} 
        />
      </div>

      {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
        <div className="table-container">
          <table className="data-table">
            <thead><tr><th>Nama OPD</th><th>Singkatan</th><th>Kepala</th><th>Dataset</th><th>Update %</th><th>Aksi</th></tr></thead>
            <tbody>
              {orgs.filter(o => o.nama?.toLowerCase().includes(search.toLowerCase()) || o.singkatan?.toLowerCase().includes(search.toLowerCase())).map(o => (
                <tr key={o._id}>
                  <td><strong style={{ fontSize: '0.85rem' }}>{o.nama}</strong></td>
                  <td><span className="badge badge-info">{o.singkatan}</span></td>
                  <td style={{ fontSize: '0.85rem' }}>{o.kepala || '-'}</td>
                  <td style={{ fontWeight: 600 }}>{o.jumlahDataset}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <div style={{ flex: 1, height: 6, background: 'var(--gray-100)', borderRadius: 3, overflow: 'hidden' }}>
                        <div style={{ width: `${o.persentaseUpdate}%`, height: '100%', background: o.persentaseUpdate >= 90 ? 'var(--success)' : o.persentaseUpdate >= 70 ? 'var(--warning)' : 'var(--danger)', borderRadius: 3 }} />
                      </div>
                      <span style={{ fontSize: '0.8rem', fontWeight: 600 }}>{o.persentaseUpdate}%</span>
                    </div>
                  </td>
                  <td><button className="btn btn-ghost btn-sm btn-icon" onClick={() => handleEdit(o)}><FiEdit2 size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 style={{ fontFamily: 'var(--font-body)', fontSize: '1.1rem' }}>{editId ? 'Edit Organisasi' : 'Tambah Organisasi'}</h3>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nama OPD *</label><input className="form-input" value={form.nama} onChange={(e) => setForm({...form, nama: e.target.value})} required /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group"><label className="form-label">Singkatan</label><input className="form-input" value={form.singkatan} onChange={(e) => setForm({...form, singkatan: e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Kepala</label><input className="form-input" value={form.kepala} onChange={(e) => setForm({...form, kepala: e.target.value})} /></div>
                </div>
                <div className="form-group"><label className="form-label">Deskripsi</label><textarea className="form-textarea" value={form.deskripsi} onChange={(e) => setForm({...form, deskripsi: e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Email</label><input className="form-input" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Batal</button>
                <button type="submit" className="btn btn-primary">Simpan</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardOrganisasi;
